import en from './locales/en.json'
import ro from './locales/ro.json'
import reducers from './redux/reducers'
import sagas from './redux/sagas'

export default {
  name: 'common',
  locales: {
    en,
    ro,
  },
  reducers,
  sagas,
}

export { default as TripsList } from './components/TripsList'
export { default as ScheduledTripsList } from './components/ScheduledTripsList'
export { default as RemoteSelect } from './components/form/RemoteSelect'
export { default as DispatchMap } from './components/map/dispatchMap'
